module.exports = __webpack_public_path__ + "images/level_second.b9666dc9171355234949170d8ae83dd1.png";